import { GameINFOV2 } from 'types/types'

export const shouldHideUIForHospitality = (game: GameINFOV2 | undefined | null) => {
  return game?.is_hospitality ?? false
}
